/* eslint-disable */
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    createdAuthorData: {},
    getAuthorData:{},
    getAuhtorDetailsByIdData:{},
    updatedAuthorData:{},
    removedAuthorData:{},
    getCourseTypeData:{},
    postCourseTypeData:{},
    getCourseTypeByIdData:{},
    updateCourseTypeByIdData:{},
    removeCourseTypeByIdData:{}
  },
  mutations: {
    createAuthorMutation(state, response) {
      state.createdAuthorData = response;
    },
    getAuthorsMutation(state, response) {
      state.getAuthorData = response;
    },
    getAuthorDetailsByIdMutation(state, response) {
      state.getAuhtorDetailsByIdData = response;
    },
    updateAuthorMutation(state, response) {
      state.updatedAuthorData = response;
    },
    removeAuthorMutation(state, response) {
      state.removedAuthorData = response;
    },
    
    getCourseTypeMutation(state, response) {
      state.getCourseTypeData = response;
    },
    postCourseTypeMutation(state, response) {
      state.postCourseTypeData = response;
    },
    getCourseTypeByIdMutation(state, response) {
      state.getCourseTypeByIdData = response;
    },
    updateCourseTypeByIdMutation(state, response) {
      state.updateCourseTypeByIdData = response;
    },
    removeCourseTypeByIdMutation(state, response) {
      state.removeCourseTypeByIdData = response;
    },
  },
  actions: {
    // Get Auhtors List
    getAuhtorsFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/courses/admin/courseauthor/?course='+ payload.id).then((response) => {
          context.commit('getAuthorsMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Author Details By Id
    getAuthorDetailsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/courses/admin/courseauthor/' + payload.id + '/').then((response) => {
          context.commit('getAuthorDetailsByIdMutation', response.data.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Create New Quiz
    createAuhtorFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/courses/admin/courseauthor/', payload).then((response) => {
          context.commit('createAuthorMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Author By ID
    updateAuthorFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/courses/admin/courseauthor/' + payload.data.id + '/', payload.data.data).then((response) => {
          context.commit('updateAuthorMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Remove Author
    removAuthorFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/courses/admin/courseauthor/' + payload.id + '/').then((response) => {
          context.commit('removeAuthorMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Course Type List
    getCourseTypeFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/courses/admin/coursetype/').then((response) => {
          context.commit('getCourseTypeMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Post Course Type List
    createCourseTypeFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/courses/admin/coursetype/', payload).then((response) => {
          context.commit('postCourseTypeMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get Course Type By Id List
    getCourseTypeByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/courses/admin/coursetype/' + payload.id + '/').then((response) => {
          context.commit('getCourseTypeByIdMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Update Course Type By Id List
    updateCourseTypeByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('/courses/admin/coursetype/' + payload.data.id + '/', payload.data.data).then((response) => {
          context.commit('updateCourseTypeByIdMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Remove Course Type By Id List
    removeCourseTypeByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/courses/admin/coursetype/' + payload.id + '/').then((response) => {
          context.commit('removeCourseTypeByIdMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
  },
  getters: {
    createdAuthorDataState: state => state.createdAuthorData,
    getAuthorDataState: state => state.getAuthorData,
    getAuhtorDetailsByIdDataState: state => state.getAuhtorDetailsByIdData,
    updatedAuthorDataState: state => state.updatedAuthorData,
    removedAuthorDataState: state => state.removedAuthorData,
    getCourseTypeDataState : state => state.getCourseTypeData,
    postCourseTypeDataState: state => state.postCourseTypeData,
    getCourseTypeByIdDataState: state => state.getCourseTypeByIdData,
    updateCourseTypeByIdDataState: state => state.updateCourseTypeByIdData,
    removeCourseTypeByIdDataState: state => state.removeCourseTypeByIdData
  }
}